import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { setModal } from 'slices/modal'
import { useFirebaseEvent } from 'hooks'
import { financialService } from 'services'
import { EVENT_STATUS, MODAL_KEYS, SESSION_KEY } from 'app-constants'
import { Button } from '../button'
import './style.scss'

export function PaymentButton({ invoiceId, event, showErrorMessage, className = '' }) {
  const [isLoading, setIsLoading] = useState(false)
  const { sendEvent } = useFirebaseEvent()
  const dispatch = useDispatch()
  const { getSydlePaymentLink } = financialService()

  async function handleOpenModalClick() {
    try {
      setIsLoading(true)
      const sessionId = localStorage.getItem(SESSION_KEY)
      const { data } = await getSydlePaymentLink(invoiceId, sessionId)

      dispatch(setModal({ key: MODAL_KEYS.PAYMENT, data: { paymentLink: data.paymentUrl } }))
      if (event) sendEvent(event)
    } catch (error) {
      console.error(error)
      const errorMessage = error?.response?.data?.message

      if (showErrorMessage) showErrorMessage(errorMessage)
      if (event) sendEvent(event, EVENT_STATUS.ERROR, errorMessage)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <Button
      id='payment-button'
      onClick={handleOpenModalClick}
      type='button'
      isLoading={isLoading}
      color='secondary'
      className={className}
    >
      Ir para pagamento
    </Button>
  )
}
